import React from 'react';
import { Clock } from 'lucide-react';
import { Link, usePage } from '@inertiajs/react';
import { AffiliateLayout } from '../../../design-system/components/layouts';
import { Button } from '../../../design-system/components';
import { root_path } from '../../../lib/routes';
export default function Pending() {
  const { props } = usePage();
  const appName = props.app_name ?? 'Speakflow';
  const supportEmail = props.app_config?.support_email;
  return (
    <AffiliateLayout>
      <div className="max-w-lg mx-auto py-16 px-4 sm:px-6 text-center">
        {/* Clock icon */}
        <div className="mx-auto w-16 h-16 rounded-full bg-warning-50 flex items-center justify-center mb-6">
          <Clock size={32} className="text-warning-500" />
        </div>

        <h1 className="text-2xl font-semibold text-fg tracking-tight">
          Application Under Review
        </h1>

        <p className="mt-4 text-fg-tertiary leading-relaxed">
          Thank you for applying to the {appName} Affiliate Program! Your application is currently
          being reviewed by our team.
        </p>

        {/* What to expect */}
        <div className="mt-8 bg-surface-secondary rounded-xl p-6 text-left">
          <h2 className="text-sm font-semibold text-fg mb-4">What to expect</h2>
          <ol className="space-y-3 text-sm text-fg-secondary">
            <li className="flex gap-3">
              <span className="shrink-0 w-6 h-6 rounded-full bg-neutral-200 text-fg-secondary text-xs font-semibold flex items-center justify-center">
                1
              </span>
              <span>Our team reviews applications within 1&ndash;2 business days.</span>
            </li>
            <li className="flex gap-3">
              <span className="shrink-0 w-6 h-6 rounded-full bg-neutral-200 text-fg-secondary text-xs font-semibold flex items-center justify-center">
                2
              </span>
              <span>You'll receive an email once a decision has been made.</span>
            </li>
            <li className="flex gap-3">
              <span className="shrink-0 w-6 h-6 rounded-full bg-neutral-200 text-fg-secondary text-xs font-semibold flex items-center justify-center">
                3
              </span>
              <span>
                If approved, you'll be guided through onboarding to set up your referral link and
                start earning commissions.
              </span>
            </li>
          </ol>
        </div>

        {/* Actions */}
        <div className="mt-8 space-y-3">
          <Link href={root_path()}>
            <Button variant="secondary" className="w-full">
              Back to Home
            </Button>
          </Link>
          {supportEmail && (
            <p className="text-xs text-fg-tertiary">
              Have questions about your application?{' '}
              <a
                href={`mailto:${supportEmail}`}
                className="text-fg hover:text-fg-secondary"
              >
                Contact support
              </a>
            </p>
          )}
        </div>
      </div>
    </AffiliateLayout>
  );
}
